import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AixueModalMask from '@/components/AixueModalMask/index';
import ScrollToTop from '@/components/ScrollToTop/index';
import Router from '@/router';
import '@/styles/main.scss';

// 导入antd样式
import 'antd/dist/reset.css';
// 导入UnoCSS样式
import 'virtual:uno.css';

import { initAnalytics, report, EVENTTYPES } from '@/utils/analytics';

initAnalytics();
report({
  event_type: EVENTTYPES.PAGE_SHOW,
  event_id: 'website_view',
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);
root.render(
  <BrowserRouter basename="/">
    <ScrollToTop />
    <Router />
    <React.Suspense fallback={null}>{AixueModalMask && <AixueModalMask />}</React.Suspense>
  </BrowserRouter>,
);
